import axios from "axios";

export const getStripeAccountId = async () => {
  const res = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/api/v1/company/payments/company-stripe-id`
  );
  return res.data;
};
